<template>
<ItpBox>
  <ItpSidebar
    default-width="400"
    scroll-y
    class="mr-2"
  >
    <UcInvoiceGeneratorControls
      ref="panel"
    >
    </UcInvoiceGeneratorControls>
  </ItpSidebar>
  <DIV
    class="h-100 w-100 overflow-hidden position-relative"
  >
    <VueSlickgrid
      :name="gridName"
      :resizeTrigger="resizeTrigger"
      :headerTitle="'Draft Invoices'|gettext"
      :items="ds"
      checkbox-row-selection
      footer-totals
      export-to-csv
      :exportToCsvFilename="'draft-invoices'|pgettext('ExportFilename')"
      :columnDefaults="b_1040167445267876_columnDefaults"
      :columns="b_1040167445267876_columns"
      class="page--grid"
      ref="grid"
      @selectedRowsChanged="evh_1040167445267876_selectedRowsChanged($event, {})"
      @command="evh_1040167445267876_command($event, {})"
    >
      <DIV
        class="flex-grow-1 d-flex"
        slot="toolbar"
      >
        <ItpButton
          :icon="$config.billingList.createItemIcon"
          :text="'Bulk edit...'|pgettext('Invoices')"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          @click="evh_7789867021953041_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :icon="$config.mergeIcon"
          :text="'Merge invoices'|gettext"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          :spinning="actions.mergeInvoices.isRunning"
          class="mx-2"
          @click="evh_3468003412020058_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          icon="fa-trash"
          :text="'Delete'|gettext"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          :spinning="actions.deleteItems.isRunning"
          class="mx-2"
          @click="evh_4834182479726849_click($event, {})"
        >
        </ItpButton>
        <JobHandlerControl
          jobType="invoice_sync"
          load-current
          :payload="() => onIssueInvoicesPayload()"
          icon="material-symbols:cloud-sync-outline-rounded"
          :text="'Issue Invoices'|pgettext('DraftInvoices|Submit')"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
        >
        </JobHandlerControl>
        <ItpLink
          :text="'Download invoice lines'|pgettext('InvoiceGeneration')"
          :href="$fn.urlFor('draft_invoice_lines_report')"
          button
          variant="light"
          use-auth
          timeout="300000"
          class="d-inline-block mx-2"
        >
        </ItpLink>
        <ArtifactJob
          icon="ic:baseline-download"
          :text="'Download views'|gettext"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
          operation="download_invoice_views"
          :payload="boundDownloadViewsPayloadMethod()"
          class="ml-2"
        >
        </ArtifactJob>
      </DIV>
    </VueSlickgrid>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceGenerationInvoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };
  sse = {
    cleanup: true,
  };

  beforeCreate() {
  }

  processMessage(...args: any[]) {
    const msg = args[0];
    if (msg.event === 'InvoiceGeneratorStatus') {
      this.$refs.panel.updateStatus(msg.data);
    }
    if (msg.event === 'InvoiceCreated') {
      this.$refs.grid.dataView.addItem(msg.data);
    }
    if (msg.event === 'InvoiceUpdated') {
      this.$refs.grid.dataView.updateItem(msg.data.id, msg.data);
    }
    if (msg.event === 'InvoiceDeleted') {
      this.$refs.grid.dataView.removeItem(msg.data.id);
    }
  }

  onIssueInvoicesPayload(...args: any[]) {
    return this.$imodal
      .show({ name: 'CompleteInvoicesAlt' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  getDownloadViewsPayload(...args: any[]) {
    return {
      identities: _.chain(this.selectedItems)
        .map(p => p.id)
        .uniq()
        .value()
    }
  }

  boundDownloadViewsPayloadMethod(...args: any[]) {
    if (!this._getDownloadViewsPayload) {
      this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
    }
    return this._getDownloadViewsPayload
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  resizeTrigger!: any;
  selectedItems!: any;
  ts!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_draft_invoices')
  }

  ux!: any;
  b_1040167445267876_columnDefaults!: any;
  b_1040167445267876_columns!: any;
  dataMembers = ['gridName', 'resizeTrigger', 'selectedItems', 'ts', 'ds', 'ux', 'b_1040167445267876_columnDefaults', 'b_1040167445267876_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "draftInvoices",
        resizeTrigger: 0,
        selectedItems: [
        ]
        ,
        ts: null,
        ds: null,
        ux: null,
        b_1040167445267876_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_1040167445267876_columns: [{
          field: "invoice",
          name: this.$fn.pgettext("BillingList", "Invoice"),
          params: {
            sortPath: "invoice.invoice_number",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("BillingList", "Company"),
          width: "100px",
          params: {
            sortPath: "company.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "partner",
          name: this.$fn.pgettext("BillingList", "Partner"),
          width: "100px",
          params: {
            sortPath: "partner.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "partner.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rentals",
          name: this.$fn.pgettext("InvoicesView", "Rentals"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "value",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "name",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "contracts",
          name: this.$fn.pgettext("InvoicesView", "Contracts"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "value",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_number",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period start"),
          params: {
            sortPath: "billing_period.start",
          }
          ,
          field: "billing_period.start",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.start",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period end"),
          params: {
            sortPath: "billing_period.end",
          }
          ,
          field: "billing_period.end",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.end",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("InvoiceBrowserView", "Billing category"),
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Net"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "vat_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "VAT"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Amount"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("InvoiceBrowserView", "Currency"),
        }
          ,
        {
          field: "invoice_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Invoice date"),
          type: "date",
        }
          ,
        {
          field: "fulfillment_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Fulfillment date"),
          type: "date",
        }
          ,
        {
          field: "due_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Due date"),
          type: "date",
        }
          ,
        {
          field: "accounting_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Accounting date"),
          type: "date",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_1040167445267876_setData_7312_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_7312, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_showModal_7314_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1040167445267876_showModal_7314, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.id,
        modal: true,
      }
      ,
    }
  }

  async evh_1040167445267876_command_7313_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_command_7313, alias=undefined
    return $event.data.column.id === 'invoice'
  }

  async evh_1040167445267876_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_command.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_reloadSlickgrid_7318_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_7789867021953041_reloadSlickgrid_7318, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_7789867021953041_close_7317_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7789867021953041_close_7317, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_7789867021953041_showModal_7316_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7789867021953041_showModal_7316, alias=undefined
    return {
      name: "BatchInvoiceEditor",
      props: {
        invoices: this.selectedItems,
      }
      ,
    }
  }

  async evh_7789867021953041_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_click.executeFromDOM(this, event, scope);
  }

  async act_3468003412020058_reloadSlickgrid_7322_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3468003412020058_reloadSlickgrid_7322, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_3468003412020058_request_7320_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3468003412020058_request_7320, alias=mergeInvoices
    return {
      operation: "merge_invoices",
      data: {
        items: _.chain(this.selectedItems)
          .filter(p => _.get(p, 'id') != null)
          .map(p => p.id)
          .uniq()
          .value()
      },
    }
  }

  async evh_3468003412020058_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3468003412020058_click.executeFromDOM(this, event, scope);
  }

  async act_4834182479726849_reloadSlickgrid_7326_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4834182479726849_reloadSlickgrid_7326, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_4834182479726849_request_7324_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4834182479726849_request_7324, alias=deleteItems
    return {
      operation: "delete_draft_invoices",
      data: {
        invoices: this.selectedItems.map(p => p.id)
      },
    }
  }

  async evh_4834182479726849_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4834182479726849_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_setData_7312: actions.SetDataAction;
    evh_1040167445267876_selectedRowsChanged_7311: actions.EventHandlerImpl;
    evh_1040167445267876_selectedRowsChanged: actions.EventHandlerGroup;
    act_1040167445267876_showModal_7314: actions.ShowModalAction;
    evh_1040167445267876_command_7313: actions.EventHandlerImpl;
    evh_1040167445267876_command: actions.EventHandlerGroup;
    act_7789867021953041_reloadSlickgrid_7318: actions.ReloadSlickgridAction;
    evh_7789867021953041_close_7317: actions.EventHandlerImpl;
    act_7789867021953041_showModal_7316: actions.ShowModalAction;
    evh_7789867021953041_click_7315: actions.EventHandlerImpl;
    evh_7789867021953041_click: actions.EventHandlerGroup;
    act_3468003412020058_reloadSlickgrid_7322: actions.ReloadSlickgridAction;
    evh_3468003412020058_success_7321: actions.EventHandlerImpl;
    act_3468003412020058_request_7320: actions.RequestAction;
    evh_3468003412020058_click_7319: actions.EventHandlerImpl;
    evh_3468003412020058_click: actions.EventHandlerGroup;
    act_4834182479726849_reloadSlickgrid_7326: actions.ReloadSlickgridAction;
    evh_4834182479726849_success_7325: actions.EventHandlerImpl;
    act_4834182479726849_request_7324: actions.RequestAction;
    evh_4834182479726849_click_7323: actions.EventHandlerImpl;
    evh_4834182479726849_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_setData_7312 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_7312_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_selectedRowsChanged_7311 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_7312,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_1040167445267876_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_selectedRowsChanged_7311],
      }
    );
    const act_1040167445267876_showModal_7314 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1040167445267876_showModal_7314_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_command_7313 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_showModal_7314,
        event: "command",
        when: this.evh_1040167445267876_command_7313_getWhen,
        displayName: "showModal",
      }
    );
    const evh_1040167445267876_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_command_7313],
      }
    );
    const act_7789867021953041_reloadSlickgrid_7318 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_7789867021953041_reloadSlickgrid_7318_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_close_7317 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_reloadSlickgrid_7318,
        event: "close",
        when: this.evh_7789867021953041_close_7317_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_7789867021953041_showModal_7316 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7789867021953041_showModal_7316_getActionArgs,
        events: [evh_7789867021953041_close_7317],
      }
    );
    const evh_7789867021953041_click_7315 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_showModal_7316,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_7789867021953041_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_click_7315],
      }
    );
    const act_3468003412020058_reloadSlickgrid_7322 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3468003412020058_reloadSlickgrid_7322_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_success_7321 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_reloadSlickgrid_7322,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3468003412020058_request_7320 = new actions.RequestAction(
      {
        actionArgs: this.act_3468003412020058_request_7320_getActionArgs,
        displayName: "mergeInvoices",
        events: [evh_3468003412020058_success_7321],
      }
    );
    const evh_3468003412020058_click_7319 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_request_7320,
        event: "click",
        displayName: "mergeInvoices",
      }
    );
    const evh_3468003412020058_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3468003412020058_click_7319],
      }
    );
    const act_4834182479726849_reloadSlickgrid_7326 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4834182479726849_reloadSlickgrid_7326_getActionArgs,
        events: [],
      }
    );
    const evh_4834182479726849_success_7325 = new actions.EventHandlerImpl(
      {
        action: act_4834182479726849_reloadSlickgrid_7326,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4834182479726849_request_7324 = new actions.RequestAction(
      {
        actionArgs: this.act_4834182479726849_request_7324_getActionArgs,
        displayName: "deleteItems",
        events: [evh_4834182479726849_success_7325],
      }
    );
    const evh_4834182479726849_click_7323 = new actions.EventHandlerImpl(
      {
        action: act_4834182479726849_request_7324,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_4834182479726849_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4834182479726849_click_7323],
      }
    );
    return {
      act_1040167445267876_setData_7312,
      evh_1040167445267876_selectedRowsChanged_7311,
      evh_1040167445267876_selectedRowsChanged,
      act_1040167445267876_showModal_7314,
      evh_1040167445267876_command_7313,
      evh_1040167445267876_command,
      act_7789867021953041_reloadSlickgrid_7318,
      evh_7789867021953041_close_7317,
      act_7789867021953041_showModal_7316,
      evh_7789867021953041_click_7315,
      evh_7789867021953041_click,
      act_3468003412020058_reloadSlickgrid_7322,
      evh_3468003412020058_success_7321,
      act_3468003412020058_request_7320,
      evh_3468003412020058_click_7319,
      evh_3468003412020058_click,
      act_4834182479726849_reloadSlickgrid_7326,
      evh_4834182479726849_success_7325,
      act_4834182479726849_request_7324,
      evh_4834182479726849_click_7323,
      evh_4834182479726849_click,
      mergeInvoices: act_3468003412020058_request_7320,
      deleteItems: act_4834182479726849_request_7324,
    }
  }
}

Vue.component("UcInvoiceGenerationInvoices", UcInvoiceGenerationInvoices);

</script>